import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setLookOverlayOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import {GroheLockIcon} from "../../../common/icons";
import WithInputValidations from "../../hocs/withInputValidations";
import LeadCapturePopupContentInputs from "./leadCapturePopupContentInputs";
import LeadCapturePopupFooter from "./leadCapturePopupFooter";
import {UserPopupContent} from "../../../visComponents/constants";
import PrivacyPolicyTerms from "../../../popups/userPopup/privacyPolicyTerms";
import LeadCapturePopupTwoFA from "./leadCapturePopupTwoFa";
import LeadCapturePopupTwoFAVerify from "./leadCapturePopupTwoFaVerify";
import {pricingIsLocked} from "../../lookNavigation/lookNavigationFunctions";
import {SHARE_BUTTONS} from "../../lookNavigation/lookSideBar/lookSidebarModals/lookSideBarShareButtons";
import LeadCapturePopupOptInCheckbox from "./leadCapturePopupOptInCheckbox";
import {getCommonVisualizerType} from "../../../../config";


const LeadCapturePopupContent = (props) => {

  const {userPopupContent, closePopup, intl, lookOverlayAction, isMobile, fabricatorData} = props;
  const fabricatorSettings = fabricatorData.settings;

  const {showPrice, pricingLocked, clickLeadCapture} = pricingIsLocked(); // leadCapture is on

  const isQuotation = fabricatorSettings.callForPricing && lookOverlayAction && lookOverlayAction === "quotation"
    && (userPopupContent === UserPopupContent.register || userPopupContent === UserPopupContent.login);

  const getTitle = () => {
    switch (userPopupContent) {
      case UserPopupContent.login:
        if (isQuotation) {
          return "leadCapturePopup.title.quotation"
        } else if (pricingLocked) {
          return "leadCapturePopup.title.login"
        }
        return "userPopup.title.visualizer";
      case UserPopupContent.register:
        if (isQuotation) {
          return "leadCapturePopup.title.quotation"
        } else if (lookOverlayAction && Object.keys(SHARE_BUTTONS).some(button => lookOverlayAction === button)) {
          return "leadCapturePopup.title.share";
        } else if (fabricatorSettings.enableQuote) {
          return "leadCapturePopup.title.getQuote";
        } else if (pricingLocked) {
          if (clickLeadCapture) {
            return "userPopup.title.visualizer";
          }
          return showPrice
            ? isMobile ? "leadCapturePopup.title.register.mobile" : "leadCapturePopup.title.register"
            : "leadCapturePopup.title.register.noPrice"
        }
        return "userPopup.title.visualizer";
      case UserPopupContent.terms:
        return "leadCapturePopup.title.terms";
      case UserPopupContent.forgot:
        return "leadCapturePopup.forgot.title";
      case UserPopupContent.twoFA:
        return "leadCapturePopup.twoFA.title";
      case UserPopupContent.twoFAVerify:
        return "grohe.cart.twoFA.verify.title";
      default:
        return ""
    }
  }

  const getSubTitle = () => {
    switch (userPopupContent) {
      case UserPopupContent.login:
      case UserPopupContent.register:
        if (fabricatorData.isNhance) {
          return "leadCapturePopup.subTitle.nhance"
        }
        if (isQuotation) {
          return ""
        } else if (lookOverlayAction && Object.keys(SHARE_BUTTONS).some(button => lookOverlayAction === button)) {
          return "leadCapturePopup.subTitle.share";
        } else if (pricingLocked) {
          return clickLeadCapture ? "leadCapturePopup.subTitle.clickCount" : "leadCapturePopup.subTitle"
        }
        return userPopupContent === UserPopupContent.login ? "leadCapturePopup.subTitle.regular.login" : "leadCapturePopup.subTitle.regular"
      case UserPopupContent.forgot:
        return "leadCapturePopup.forgot.subTitle";
      case UserPopupContent.twoFA:
        return "grohe.cart.twoFA.subTitle";
      case UserPopupContent.twoFAVerify:
        return "grohe.cart.twoFA.verify.subTitle";
      default:
        return ""
    }
  }

  const getContent = (inputsValidated) => {
    switch (userPopupContent) {
      case UserPopupContent.login:
      case UserPopupContent.register:
      case UserPopupContent.forgot:
        return <LeadCapturePopupContentInputs inputsValidated={inputsValidated}/>
      case UserPopupContent.terms:
        return <PrivacyPolicyTerms/>
      case UserPopupContent.twoFA:
        return <LeadCapturePopupTwoFA inputsValidated={inputsValidated}/>;
      case UserPopupContent.twoFAVerify:
        return <LeadCapturePopupTwoFAVerify closePopup={closePopup}/>;
      default:
        return null
    }
  }

  const subTitle = getSubTitle();

  return (
    <WithInputValidations>
      {(inputsValidated, updateInputValidations) => (
        <div className="grohe-lead__left">
          <header className={"grohe-lead__header" + (userPopupContent !== UserPopupContent.terms ? " grohe-lead__header--min" : "") }>
            {pricingLocked ? (
              <div className="grohe-lead__header-icon">
                <SvgIcon fontSize={"inherit"}>
                  <GroheLockIcon className="lm-locked__icon"/>
                </SvgIcon>
              </div>
            ) : null}
            <div className={"grohe-lead__header-content" + (isQuotation ? " grohe-lead__header-content--two-lines" : "")}>
              {fabricatorData.isNhance ? (
                <div className="flex flex--between">
                  <div className="grohe-lead__header-left">
                    <h2 className={"h2 h2--big text-left" + (pricingLocked ? " h2--with-locked" : "")}>
                      Save Design <br/> & Schedule Free Consult
                    </h2>
                  </div>
                  <div className={"grohe-lead__header-logo" + (pricingLocked ? " grohe-lead__header-logo--with-locked" : "")}>
                    <img id="default-logo" src="https://qc-cdn.s3.amazonaws.com/Logos/nhance-logo-webp.webp" alt="N-Hance Wood Refinishing Logo" loading="eager"/>
                  </div>
                </div>
              ) : (
                <h2 className="h2 h2--big text-left">
                  <FormattedMessage id={getTitle()} values={{
                    visualizerType: intl.formatMessage({id: "rooms." + getCommonVisualizerType()}),
                  }}/>
                </h2>
              )}
              {isQuotation ? (
                <h2 className="h2 h2--big text-left">
                  <FormattedMessage id="leadCapturePopup.title.quotation2"/>
                </h2>
              ) : null}
              {subTitle ? (
                <p className={"grohe-lead__header-content-sub-title"
                  + (fabricatorData.isNhance ? " grohe-lead__header-content-sub-title--two-lines" : "")}>
                  <FormattedMessage id={subTitle}/>
                </p>
              ) : null}
              <div className="grohe-lead__header-close">
                <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                            className="look-icon look-icon--small"
                            onClick={closePopup}>
                  <CloseIcon/>
                </IconButton>
              </div>
            </div>
          </header>
          <div className={"text-left grohe-lead__content" + (userPopupContent === UserPopupContent.terms ? " grohe-lead__content--terms" : "")}>
            {getContent(inputsValidated)}
          </div>
          {fabricatorData.isNhance && userPopupContent === UserPopupContent.register && false ? <LeadCapturePopupOptInCheckbox/> : null}
          {lookOverlayAction === "termsOnly"
            ? null
            : <LeadCapturePopupFooter updateInputValidations={updateInputValidations} closePopup={closePopup}/>}
        </div>
      )}
    </WithInputValidations>
  )
};

LeadCapturePopupContent.propTypes = {
  closePopup: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {userPopupContent} = store.userState;
  const {lookOverlayAction} = store.lookState;
  const {isMobile} = store.serverState;
  const fabricatorData = store.fabricatorState;

  return {
    userPopupContent,
    lookOverlayAction,
    isMobile,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopupContent)
)
